import useLogOut from '@src/hooks/useLogOut';
import { useUserIdentity, useVideoCreatorStore } from '@src/stores-v2';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import OrganizationAvatarTooltip from './OrganizationAvatarTooltip';
import OrganizationAvatarWithTooltip from './OrganizationAvatarWithTootlip';

type OrganizationSwitcherAvatarProps = {
  logoSize?: number;
};

function SingleOrganizationAvatar({
  logoSize = 34,
}: OrganizationSwitcherAvatarProps) {
  const videoCreator = useVideoCreatorStore();
  const userIdentity = useUserIdentity();
  const { logOut } = useLogOut();

  const album = videoCreator.organization;
  const email = userIdentity.currentIdentity?.email;
  const username = userIdentity.currentEditor;

  const renderReactTooltip = useCallback(
    () => <OrganizationAvatarTooltip onLogOut={logOut} email={email} />,
    [email, logOut],
  );

  return (
    <OrganizationAvatarWithTooltip
      album={album}
      username={username}
      logoSize={logoSize}
      renderReactTooltip={renderReactTooltip}
    />
  );
}

export default observer(SingleOrganizationAvatar);
